import type { GeneratedFile } from '@cli-types/core-engine/schema.js'
import type { MergeOutput } from '@cli-types/core-engine/snapshots.js'
import { splitLines } from '@cli-utils/text.js'
import { mergeDiff3 } from 'node-diff3'

export function mergeGeneratedFile(
  base: GeneratedFile,
  localContent: string,
  remote: GeneratedFile
): MergeOutput {
  const merged = mergeDiff3(
    splitLines(localContent),
    splitLines(base.content),
    splitLines(remote.content),
    {
      excludeFalseConflicts: true,
      label: {
        a: 'LOCAL',
        o: 'BASE',
        b: 'REMOTE'
      }
    }
  )

  return {
    file: {
      path: remote.path,
      content: merged.result.join('\n')
    },
    conflict: merged.conflict
  }
}
